// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] || chunkId) + "." + {"265":"f41f5b4b","297":"470628fb","643":"a8dc72df","959":"6ef36ac8"}[chunkId] + ".chunk.js";
};